import { Box, Container, LinearProgress } from "@mui/material";
import { useLayoutEffect } from "react";
import { Outlet, useLocation } from "react-router";
import { useCase } from "../context/CaseContext.tsx";
import { useTheme } from "../context/ThemeContext.tsx";
import { applyClaimKindTerms } from "../i18n/i18n.ts";
import { CaseNavigation } from "./CaseNavigation.tsx";
import { GuideProvider } from "./guide/GuideContext.tsx";
import { GuidePanel } from "./guide/GuidePanel.tsx";
import { guidePageOf } from "./guide/guidePages.ts";

export const CasePage = () => {
  const { theme } = useTheme();
  const caseContext = useCase();
  const { isSaving: isCalculating } = caseContext;
  const { pathname } = useLocation();
  // the terms of the kind of the claim, while it is open
  const claimKind = caseContext.getCase().claimKind;
  useLayoutEffect(() => {
    applyClaimKindTerms(claimKind);
    return () => applyClaimKindTerms(undefined);
  }, [claimKind]);

  return (
    <GuideProvider page={guidePageOf(pathname)}>
      <Box
        sx={{
          display: "flex",
        }}
      >
        <CaseNavigation />
        <Box sx={{ flexGrow: 1, minWidth: 0, overflow: "auto" }}>
          {isCalculating && <LinearProgress />}
          <Container
            maxWidth="lg"
            sx={{
              mt: theme.spacing(2),
              opacity: isCalculating ? 0.5 : 1,
              pointerEvents: isCalculating ? "none" : "auto",
              transition: "opacity 0.2s",
            }}
          >
            <Outlet />
          </Container>
        </Box>
        <GuidePanel />
      </Box>
    </GuideProvider>
  );
};
